/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/**
 * Color siblings: every color is its own product, linked by a shared base SKU (ex: 6000280_19-4020 => 6000280).
 * The list is rendered by sections/product-color-siblings.liquid and loaded here through the Section Rendering API.
 */
(function () {
  var CACHE_PREFIX = 'color-siblings:';

  function getCached(url) {
    try {
      return sessionStorage.getItem(CACHE_PREFIX + url);
    } catch (error) {
      return null;
    }
  }

  function setCached(url, html) {
    try {
      sessionStorage.setItem(CACHE_PREFIX + url, html);
    } catch (error) {}
  }

  function render(container, html) {
    var list = container.querySelector('[data-color-siblings-list]'),
        count = container.querySelector('[data-color-siblings-count]'),
        currentHandle = container.getAttribute('data-current-handle'),
        doc = new DOMParser().parseFromString(html, 'text/html'),
        seen = {};

    var items = Array.prototype.slice.call(doc.querySelectorAll('[data-color-siblings-items] .ColorSibling')).filter(function (item) {
      var handle = item.getAttribute('data-handle');

      if (seen[handle]) {
        return false;
      }

      seen[handle] = true;
      return true;
    });

    // The current product must be part of the list, otherwise the search did not return what we expect
    if (items.length < 2 || !seen[currentHandle]) {
      return;
    }

    // Search results are ordered by relevance, we sort by SKU so the colors always show in the same order
    items.sort(function (a, b) {
      return a.getAttribute('data-sku').localeCompare(b.getAttribute('data-sku'));
    });

    list.innerHTML = '';

    items.forEach(function (item) {
      if (item.getAttribute('data-handle') === currentHandle) {
        item.classList.add('is-active');
        item.setAttribute('aria-current', 'true');
      }

      list.appendChild(document.importNode(item, true));
    });

    if (count) {
      count.textContent = (count.getAttribute('data-label') || '__COUNT__').replace('__COUNT__', items.length);
    }

    container.removeAttribute('hidden');
  }

  function load(container) {
    var url = container.getAttribute('data-color-siblings-url'),
        cached = getCached(url);

    if (cached) {
      render(container, cached);
      return;
    }

    fetch(url, { credentials: 'same-origin' }).then(function (response) {
      return response.ok ? response.text() : Promise.reject(response.status);
    }).then(function (html) {
      setCached(url, html);
      render(container, html);
    }).catch(function () {});
  }

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-color-siblings-url]'), load);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
